import React from "react";

const AllFutureCheckbox = ({ allFuture, onToggleAllFuture }) => {
  return (
    <span className="allDates">
      <input type="checkbox" checked={allFuture} onChange={onToggleAllFuture} />
      <label htmlFor="allDates">All Future</label>
    </span>
  );
};

export default AllFutureCheckbox;
